import { render } from "./WidgetContainerComponent.vue?vue&type=template&id=f5ca48c0&scoped=true"
const script = {}

import "./WidgetContainerComponent.vue?vue&type=style&index=0&id=f5ca48c0&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f5ca48c0"]])

export default __exports__